
import React from "react";
import "../css/junaeb.css";

import abril from "../img/Junaeb/Minuta Abril 2026.jpg";
import mayo from "../img/Junaeb/Minuta Mayo 2026.jpg";
import junio from "../img/Junaeb/Minuta Junio 2026.jpg";
import julio from "../img/Junaeb/Minuta Julio 2026.png";
import agosto from "../img/Junaeb/Minuta Agosto 2026.png";
import septiembre from "../img/Junaeb/Minuta Septiembre 2026.png";
import octubre from "../img/Junaeb/Minuta Octubre 2026.png";




const Listajunaeb = () => {

    const minutas = [
       

        {
            title: "Minuta Abril 2026",
            image: abril,
            pdf: "/pdfs/Minuta Abril 2026.pdf"
        },

        {
            title: "Minuta Mayo 2026",
            image: mayo,
            pdf: "/pdfs/Minuta Mayo 2026.pdf"
        },

        {
            title: "Minuta Junio 2026",
            image: junio,
            pdf: "/pdfs/Minuta Junio 2026.pdf"
        },

        {
            title: "Minuta Julio 2026",
            image: julio,
            pdf: "/pdfs/Minuta Julio 2026.pdf"
        },
        
        {
            title: "Minuta Agosto 2026",
            image: agosto,
            pdf: "/pdfs/Minuta Agosto 2026.pdf"
        },

         {
            title: "Minuta Septiembre 2026",
            image: septiembre,
            pdf: "/pdfs/Minuta Septiembre 2026.pdf"
        },

        {
            title: "Minuta Octubre 2026",
            image: octubre,
            pdf: "/pdfs/Minuta Octubre 2026.pdf"
        },


    ];

    return (

        <section id="Listajunaeb" className="nz-container">

            <div className="nz-header">

                <h2 className="nz-title">
                    Alimentación JUNAEB
                </h2>

                <p className="nz-subtitle">
                    Consulte aquí las minutas mensuales del Programa de Alimentación Escolar.
                </p>

            </div>

            <div className="nz-grid">

                {minutas.map((minuta, index) => (

                    <a
                        key={index}
                        href={minuta.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nz-card"
                        title={minuta.title}
                    >

                        <div className="nz-image-wrapper">

                            <img
                                src={minuta.image}
                                alt={minuta.title}
                                className="nz-image"
                            />

                        </div>

                    </a>

                ))}

            </div>

        </section>

    );

};

export default Listajunaeb;